/**
 * Inbound message types: parent window → standalone iframe (postMessage).
 * Consumed by MessageRouter<InboundMessageType> in standalone/index.ts.
 *
 * Outbound types (iframe → parent) live in `widget-types.ts` as `WidgetEventType`.
 */
export type InboundMessageType =
  | 'INITIALIZE_SERVICE'
  | 'GAME_EVENT'
  | 'SET_DEALER_MUTE'
  | 'START_AUDIO'
  | 'UPDATE_WIDGET_PROPS'
  // Welcome handshake (see docs/decisions/0039-ai-audio-mic-enablement.md):
  // game enters/exits the welcome moment; widget runs the audio probe on ENTER.
  | 'ENTER_WELCOME'
  | 'EXIT_WELCOME';

/**
 * Version of the parent↔iframe postMessage handshake. Carried in the
 * SERVICE_READY and INITIALIZE_SERVICE payloads; the embedded lib and the
 * deployed iframe can be years apart, so a mismatch is logged for fleet
 * visibility but never fails the handshake — the protocol only evolves
 * additively (versioning policy: ADR 0037).
 */
export const POSTMESSAGE_PROTOCOL_VERSION = 1;

/** Absence of the field = v1: every pre-versioning build speaks protocol 1. */
export function resolveProtocolVersion(value: unknown): number {
  return typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : 1;
}
